import type { SVGProps } from "react";
import { Icon, type IconProps } from "../Icon";
const InternalSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      d="m9.5 11.5-1-4"
      style={{
        stroke: "var(--icon-accent,#E47B53)",
      }}
    />
    <path
      d="M8.353 11.022a.5.5 0 1 0 .294.956L8.5 11.5zM15 9.5l-.147-.478-6.5 2 .147.478.147.478 6.5-2z"
      style={{
        fill: "var(--icon-accent,#E47B53)",
      }}
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="m19.338 13.58 2.208-.746-1.677-4.969a4.08 4.08 0 0 0-5.17-2.56S7.283 6.58 3.5 9.5c-1.956 1.51-.905 3.001.465 3.65m1.017 5.275 2.208-.745m-3.225-4.53C4.523 10.81 6.5 11.372 6.5 12.5c0 1.143-1.38 1.195-2.535.65m0 0c-.184.772-.213 1.86.035 3.35"
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M19.87 7.865a4.08 4.08 0 0 0-5.17-2.56l-1.104.372L14.9 9.542l5.529-.02z"
      style={{
        stroke: "var(--icon-accent,#E47B53)",
      }}
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M7.922 16.203a1.166 1.166 0 1 1 .745 2.21 1.166 1.166 0 0 1-.745-2.21M17.861 12.848a1.166 1.166 0 1 1 .745 2.21 1.166 1.166 0 0 1-.745-2.21M9.4 16.934l7.73-2.609"
    />
  </svg>
);
export const BusSpecialIcon = (props: IconProps) => (
  <Icon {...props} Icon={InternalSvg} />
);
